module.exports = __webpack_public_path__ + "static/media/ferrari__black-gold.8da655d2.jpg";